import React, { useEffect, useState } from 'react';
import { Input , Form, DatePicker, Button, Table, Dropdown, Menu, Divider, Row, Col, Modal} from 'antd';

import { faAngleDown, faArrowDown, faFileInvoice, faPlus, faPrint, faTrash } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import {useDevolucao} from '../../hooks/use-devolucao';
import {useAxios} from '../../hooks';
import { Dinheiro } from '@contentsys/contentsys-react-components';
import { LayoutImpressaoDevolucao } from '../componentes/layout-impressao-devolucao';


const GerenciarDevolucoes = () => {

    const [form] = Form.useForm();

    const {getApiEmitirNotas} = useAxios();

    const {buscarDevolucao, excluirDevolucao} = useDevolucao(getApiEmitirNotas);

    const [excluindo, setExcluindo] = useState(false);

    const [devolucaoSelecionada, setDevolucaoSelecionada] = useState();
    const [chaveDevolucaoSelecionada, setChaveDevolucaoSelecionada] = useState([]);

    const [openImpressaoDevolucaoEvt, setOpenImpressaoDevolucao] = useState()

    const [devolucoes, setDevolucoes] = useState([]);

    const [acoesDesabilitadas, setAcoesDesabilitadas] = useState(true);

    useEffect(() => {
        form.setFieldsValue({
            periodo: [moment(moment().format("YYYY-MM-01"), "YYYY-MM-DD"), moment()]
        })
    }, [])
    const buscar = async () => {

        const {termo="", periodo} = form.getFieldsValue(true);

        const devs = await buscarDevolucao(termo, periodo[0].format("YYYY-MM-DD"), periodo[1].format("YYYY-MM-DD"));

        console.log(devs)
        setDevolucoes(devs);
        
    }

    const imprimir = () => {
        openImpressaoDevolucaoEvt.send();
    }

    const excluir = () =>{
        Modal.confirm({
            title: 'Tem certeza disso?',
            content: (
              <div>
                <p style={{fontSize: "0.9em"}}>Essa operação não pode mais ser desfeita.</p>
              </div>
            ),
            okText: "Sim",
            cancelText: "Não",
            confirmLoading: excluindo, 
            onOk: async ()=> {
                setExcluindo(true);
                await excluirDevolucao(devolucaoSelecionada);
                await buscar();
                setExcluindo(false);
            },
            onCancel: () => {}
          });
    }

    return (
        <>
            <h1 style={{textAlign: "left"}}>  Gerenciar Devoluções</h1> 
            <div style={{
                position: "sticky",                
                top: "55px",
                background: "#f0f2f5",
                padding: "24px 5px",
                zIndex: '1'
            }}>
                <Form layout="inline" form={form}>
                    <Form.Item 
                        name="termo"
                        
                    >
                        <Input value="" placeholder="N. Dev ou cliente"></Input>
                    </Form.Item>

                    <Form.Item
                        name="periodo"
                        label="Periodo"
                        required={true}
                    >
                        <DatePicker.RangePicker format="DD/MM/YYYY"></DatePicker.RangePicker>
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" onClick={buscar}>Buscar</Button>
                    </Form.Item>

                    <Form.Item>
                        <Dropdown 
                            trigger={["click"]}
                            disabled={acoesDesabilitadas}
                            overlay={
                                <Menu>
                                    
                                    {/* <Menu.Item key="3" icon={<FontAwesomeIcon icon={faFileInvoice}></FontAwesomeIcon>}>
                                        Emitir NF-e
                                    </Menu.Item> */}
                                    <Menu.Item onClick={imprimir} key="1" icon={<FontAwesomeIcon icon={faPrint}></FontAwesomeIcon>}>
                                        Imprimir Comprovante
                                    </Menu.Item>
                                    {/* <Divider style={{margin: "0"}}></Divider> */}
                                    <Menu.Item key="2" onClick={excluir} icon={<FontAwesomeIcon style={{color: "red"}} icon={faTrash}></FontAwesomeIcon>}>
                                        Excluir
                                    </Menu.Item>
                                </Menu>
                            }
                        >
                            <Button>Ações <FontAwesomeIcon style={{marginLeft: "5px"}} icon={faAngleDown}></FontAwesomeIcon></Button>

                        </Dropdown>
                    </Form.Item>
                    
                </Form>
            </div>
            {/* <Folha> */}
            <Row>
                <Col span={24}>
                <Table  
                    rowSelection={{
                        type: "radio",
                        onChange: (selectedRowKeys, selectedRows) => {
                            console.log("acoes", selectedRowKeys.length)
                            setAcoesDesabilitadas(!(selectedRowKeys.length > 0))
                            
                            setDevolucaoSelecionada(selectedRows[0]);
                        }
                    }}
                    
                    rowKey="uuid"
                    size="small"

                    dataSource={devolucoes}

                    columns={[
                    {
                        title: '#',
                        dataIndex: 'numeroDevolucao',
                        key: 'numeroDevolucao'
                    },{
                        title: 'Cliente',
                        dataIndex: 'identificacaoCliente',
                        key: 'identificacaoCliente'
                    },{
                        title: 'Data',
                        dataIndex: 'createdAt',
                        key: 'createdAt',
                        render: (text, record) => {
                            const data = moment(record.createdAt).format("DD/MM/YYYY HH:mm:ss");
                            return <>{data}</>;
                        }
                    },{
                        title: 'Total',
                        dataIndex: 'valorTotalDevolvido',
                        key: 'valorTotalDevolvido',
                        render: valor => {
                            return <Dinheiro value={valor} />
                        }
                    }]}
                >

                </Table>
                </Col>
            </Row>

            <LayoutImpressaoDevolucao setOpenEvent={setOpenImpressaoDevolucao} devolucao={devolucaoSelecionada}></LayoutImpressaoDevolucao>
            {/* </Folha> */}
        </>
    );
};

export {GerenciarDevolucoes};